<script setup>

defineProps({
    message: String,
});
</script>

<template>
    <div v-show="message" class="text-red-500 flex gap-2.5 items-start leading-120 px-2.5 text-sm">
        <ion-icon class="w-4 shrink-0" name="alert-circle" style="width: 20px; height: 20px"></ion-icon>
        <span>{{ message }}</span>
    </div>
</template>
